module.exports = __webpack_public_path__ + "assets/images/USDNEW10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDNEW10.png
// module id = 1459
// module chunks = 1